import FuxHTTP from "../../lib/FuxFramework/FuxHTTP";
import AuthAPI from "./../AuthAPI";
import APIConfig from "./../APIConfig";


export const _User = {
    getDisputes: function (status) {
        let params = {
            token: AuthAPI.currentUser.accessToken,
            status: status,
        }
        return FuxHTTP.apiGetRequestWithPromise(
            APIConfig.url(`/disputes/user/get-disputes`), params,
            FuxHTTP.RESOLVE_DATA,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    acceptRefund: function (id_messaggio) {
        let params = {
            token: AuthAPI.currentUser.accessToken,
            id_messaggio: id_messaggio,
        }
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url(`/disputes/user/accept-refund`), params,
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    },
    rejectRefund: function (id_messaggio) {
        let params = {
            token: AuthAPI.currentUser.accessToken,
            id_messaggio: id_messaggio,
        }
        return FuxHTTP.apiPostRequestWithPromise(
            APIConfig.url(`/disputes/user/reject-refund`), params,
            FuxHTTP.RESOLVE_MESSAGE,
            FuxHTTP.REJECT_MESSAGE
        );
    },
};